import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { GET_TREE_RESTRICTIONS, GET_TREE_STATE, UPDATE_TREE } from "../../queries";
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
let idGenerator = 0;
let elements = {};
export const getTreeId = name => {
  var _elements$name;
  return (_elements$name = elements[name]) !== null && _elements$name !== void 0 ? _elements$name : (elements = _objectSpread(_objectSpread({}, elements), {}, {
    [name]: idGenerator++
  }))[name];
};
export const getTreeName = id => {
  var _Object$keys$find;
  return (_Object$keys$find = Object.keys(elements).find(el => elements[el] == id)) !== null && _Object$keys$find !== void 0 ? _Object$keys$find : 'Initial';
};
const createStateTree = name => {
  const id = getTreeId(name);
  return {
    __typename: 'StateTreeDto',
    buttonConfig: '{"label":"' + name + '","color":"","icon":"","active":true,"iconColor":"","confirmationPopup":""}',
    action: 'Área 2-B-2',
    id: id,
    treeNext: {
      id: id,
      code: name
    }
  };
};
const transitions = {
  Initial: ['Control_affecté'],
  Control_affecté: ['Control_OK', 'Control_KO'],
  Control_KO: ['Control_affecté'],
  Control_OK: ['Valide'],
  Valide: []
};
window.status = 'Initial';
const treeRestrictionsMocks = Object.keys(transitions).reduce((rec, state) => {
  const id = getTreeId(state);
  return _objectSpread(_objectSpread({}, rec), {}, {
    [state]: transitions[state].map(trans => createStateTree(trans))
  });
}, {});
export default [{
  request: {
    query: GET_TREE_RESTRICTIONS,
    variables: MATCH_ANY_PARAMETERS
  },
  result: variables => {
    return {
      data: {
        read_tree_restrictions: treeRestrictionsMocks[window.status]
      }
    };
  }
}, {
  request: {
    query: UPDATE_TREE,
    variables: MATCH_ANY_PARAMETERS
  },
  result: variables => {
    window.status = getTreeName(variables === null || variables === void 0 ? void 0 : variables.newTreeId);
    return {
      data: {
        tree_update: {
          treelevel1: window.status,
          treelevel2: undefined,
          treelevel3: undefined,
          treelevel4: undefined
        }
      }
    };
  }
}, {
  request: {
    query: GET_TREE_STATE,
    variables: MATCH_ANY_PARAMETERS
  },
  result: variables => {
    return {
      data: {
        tree_readState: {
          treelevel1: window.status,
          treelevel2: undefined,
          treelevel3: undefined,
          treelevel4: undefined
        }
      }
    };
  }
}];